import Svg from "../../_assets/svg";

export const PersonalData = [
  {
    id: "/profile/edit-profile",
    title: "Edit Profile",
    svg: Svg.user.default,
    svg_active: Svg.user_active.default
  }, 
  {
    id: "/profile/edit-organization",
    title: "Edit Organization",
    svg: Svg.u_bag.default,
    svg_active: Svg.u_bag_active.default
  },
  // {
  //   id: "/profile/notification-settings",
  //   title: "Notification Settings",
  //   svg: Svg.notif_inactive.default,
  //   svg_active: Svg.notif_active.default
  // }
  // {
  //   id: "/profile/change-password",
  //   title: "Change Password",
  //   svg: Svg.locked.default,
  //   svg_active: Svg.locked_active.default
  // }
]

export const OrganizationData = [
  {
    id: "/profile/edit-organization",
    title: "Edit Organization",
    svg: Svg.u_bag.default,
    svg_active: Svg.u_bag_active.default
  }
]

export default { PersonalData, OrganizationData };